import {
	PdfUserSettingsCategories,
	useStorePdfUserSettings,
} from 'modules/Shared/PdfPrint/usePdfUserSettings';

const serviceProtocolPdfSettingsCategories: PdfUserSettingsCategories = {
	dealer: 'PdfSettingsDealer',
	customer: 'PdfSettingsCustomer',
};

const useStorePdfServiceProtocolPrintoutSettings = () =>
	useStorePdfUserSettings(serviceProtocolPdfSettingsCategories);

export default useStorePdfServiceProtocolPrintoutSettings;
